import React from 'react'
import html from '../assets/html.png'
import css from '../assets/css.png'
import javascript from '../assets/javascript.png'
import reactImage from '../assets/react.png'
// import ruby from '../assets/ruby.png'
import rails from '../assets/rails.png'
// import sql from '../assets/sql.png'
import figma from '../assets/figma.png'
import tailwind from '../assets/tailwind.png'
import AliCloud from '../assets/aliCloud.png'

const Skills = () => {

  const techs = [
    {
      id: 1,
      src: html,
      title: 'HTML',
      style: 'shadow-orange-800'
    },
    {
      id: 2,
      src: css,
      title: 'CSS',
      style: 'shadow-blue-500'
    },
    {
      id: 3,
      src: javascript,
      title: 'JavaScript',
      style: 'shadow-yellow-500'
    },
    {
      id: 4,
      src: reactImage,
      title: 'React',
      style: 'shadow-sky-500'
    },
    // {
    //   id: 5,
    //   src: ruby,
    //   title: 'Ruby',
    //   style: 'shadow-red-900'
    // },
    {
      id: 6,
      src: rails,
      title: 'Ruby on Rails',
      style: 'shadow-red-600'
    },
    {
      id: 7,
      src: tailwind,
      title: 'TailWind',
      style: 'shadow-sky-300'
    },
    // {
    //   id: 8,
    //   src: sql,
    //   title: 'SQL',
    //   style: 'shadow-blue-500'
    // },
    {
      id: 9,
      src: figma,
      title: 'Figma',
      style: 'shadow-gray-500'
    },
    {
      id: 10,
      src: AliCloud,
      title: 'Ali Cloud',
      style: 'shadow-orange-500'
    }
  ]

  return (
    <div name='skills' className='bg-gradient-to-b from-gray-800 via-gray-800 to-black w-full h-screen'>
      <div className='max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-[#E1DFDF]'>
        <div>
          <p className='text-3xl font-bold border-b-4 border-gray-500 inline'>Skills</p>
          <p className='py-2'>These are the technologies I&apos;ve worked with</p>
        </div>

        <div className='w-full grid grid-cols-3 sm:grid-cols-4 gap-8 text-center py-6 px-10 sm:px-2'>
          {
            techs.map(({id, src, title, style}) => (
              <div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}>
                <img src={src} alt="" className='w-16 sm:w-20 mx-auto' />
                <p className='mt-2'>{title}</p>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default Skills
